export const GENERIC_PAYMENT_TOAST_CONTAINER = "generic-payment-toast";
